module.exports = __webpack_public_path__ + "static/media/swatchbook.56839b8b.svg";